/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { Tooltip, Typography } from 'antd';
import { t } from 'i18next';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

/**
 * Format a live-chat system message
 * @param {String} text The text to process.
 */
const formatLiveChatSystemMessage = (text) => {
  if (!text) {
    return;
  }

  // This regular expression is used to find error codes within the text
  const errorCodeRegex = /\[(.*?)\]\(##(.*?)\)./;
  const match = text.match(errorCodeRegex);
  const textCopy = text.replace(errorCodeRegex, '');

  // We want to add a tooltip with the error description to the error code displayed
  if (match) {
    return (
      <Typography.Text>
        <ReactMarkdown
          skipHtml
          allowedElements={['p', 'strong', 'em', 'ul', 'ol', 'li', 'img', 'a']}
          unwrapDisallowed
          linkTarget={'_blank'}
          className="markdown-inline mr-1"
        >
          {textCopy}
        </ReactMarkdown>
        <Tooltip
          title={match[1] ?? t('Unknown error')}
        >
          <span className="error-code">
            {match[2]}
          </span>
        </Tooltip>
        .
      </Typography.Text>
    );
  } else {
    // If no error code exists return the message as is
    return (
      <ReactMarkdown
        skipHtml
        allowedElements={['p', 'strong', 'em', 'ul', 'ol', 'li', 'img', 'a']}
        unwrapDisallowed
        linkTarget={'_blank'}
      >
        {text}
      </ReactMarkdown>
    );
  }
};

export default formatLiveChatSystemMessage;
